import { type RootState } from "@ds/store/bootstrap";

const selectBaseState = (state: RootState) => state.assets.common;

export const selectCurrentAssetsView = (state: RootState) => selectBaseState(state).viewType;
